import { DataDocument, PresetDefinition, rootDataId } from '@fillip/api';

const BrainstormingToolInstance: DataDocument = {
  id: 'BrainstormingToolInstance',
  info: {
    title: 'Brainstorming',
    icon: 'comments',
    toolEditing: {
      preferredArrangement: 'topbar-main',
      editors: {
        title: {
          id: 'BrainstormingToolInstance',
        },
        properties: {
          id: 'BrainstormingToolInstance',
          title: 'Einstellungen',
        },
      },
    },
  },
  tag: {
    tag: 'template',
  },
  arrangement: {
    type: 'arrangement.absolute',
  },
  list: {
    items: [
      {
        id: 'BrainstormingCollection',
      },
    ],
  },
  children: {
    default: [
      {
        templateId: 'tool-collection',
        query: ':[data]',
      },
    ],
  },
  properties: {
    showCollectionTitle: {
      type: 'boolean',
      value: false,
    },
    showAuthor: {
      type: 'boolean',
      value: false,
    },
    showTime: {
      type: 'boolean',
      value: false,
    },
    showAvatar: {
      type: 'boolean',
      value: false,
    },
    // allowReplies: {
    //   type: 'boolean',
    //   value: false,
    // },
    allowPinning: {
      type: 'boolean',
      value: true,
    },
    allowAnswered: {
      type: 'boolean',
      value: false,
    },
    allowHighlight: {
      type: 'boolean',
      value: true,
    },
    allowUpvotes: {
      type: 'boolean',
      value: false,
    },
    // chatStyle: {
    //   type: 'boolean',
    //   value: true,
    // },
    randomColors: {
      type: 'boolean',
      value: true,
    },
    grid: {
      type: 'boolean',
      value: true,
    },
    // sortByUpvotes: {
    //   type: 'boolean',
    //   value: true,
    // },
  },
  schema: {
    fields: [],
    ownFields: [
      {
        title: 'Zeige Collection-Titel',
        key: 'showCollectionTitle',
        type: 'boolean',
      },
      {
        title: 'Zeige Autor*in',
        key: 'showAuthor',
        type: 'boolean',
      },
      {
        title: 'Zeige Zeit',
        key: 'showTime',
        type: 'boolean',
      },
      {
        title: 'Zeige Avatar',
        key: 'showAvatar',
        type: 'boolean',
      },
      // {
      //   title: 'Antworten erlauben',
      //   key: 'allowReplies',
      //   type: 'boolean',
      // },
      {
        title: 'Pinnen erlauben',
        key: 'allowPinning',
        type: 'boolean',
      },
      {
        title: 'Highlighten erlauben',
        key: 'allowHighlight',
        type: 'boolean',
      },
      {
        title: '"Beantwortet" erlauben',
        key: 'allowAnswered',
        type: 'boolean',
      },
      {
        title: 'Upvotes erlauben',
        key: 'allowUpvotes',
        type: 'boolean',
      },
      {
        title: 'Zufällige Farben',
        key: 'randomColors',
        type: 'boolean',
      },
      {
        title: 'Grid-Styling',
        key: 'grid',
        type: 'boolean',
      },

      //   {
      //     title: 'Chat-Styling',
      //     key: 'chatStyle',
      //     type: 'boolean',
      //   },
    ],
  },
  variables: {
    variables: [
      {
        identifier: 'templateParent',
        query: ':id',
      },
      {
        identifier: 'collectionDocument',
        query: 'BrainstormingCollection',
      },
      {
        identifier: 'currentParent',
        query:
          ":getVolatileProp($$templateParent, 'currentParent', $$collectionDocument)",
      },
      {
        identifier: 'toolTitle',
        query: ':info.title',
      },
      {
        identifier: 'showCollectionTitle',
        query: ":getPropFrom('showCollectionTitle')(id) == true",
      },
      {
        identifier: 'showAuthor',
        query: ":getPropFrom('showAuthor')(id) == true",
      },
      {
        identifier: 'showTime',
        query: ":getPropFrom('showTime')(id) == true",
      },
      {
        identifier: 'showAvatar',
        query: ":getPropFrom('showAvatar')(id) == true",
      },
      {
        identifier: 'allowReplies',
        // query: ":getPropFrom('allowReplies')(id) == true",
        query: ':false',
      },
      {
        identifier: 'allowPinning',
        query: ":getPropFrom('allowPinning')(id) == true",
      },
      {
        identifier: 'allowHighlight',
        query: ":getPropFrom('allowHighlight')(id) == true",
      },
      {
        identifier: 'allowAnswered',
        query: ":getPropFrom('allowAnswered')(id) == true",
      },
      {
        identifier: 'allowUpvotes',
        query: ":getPropFrom('allowUpvotes')(id) == true",
      },
      {
        identifier: 'chatStyle',
        // query: ":getPropFrom('chatStyle')(id) == true",
        query: ':false',
      },
      {
        identifier: 'sortByUpvotes',
        query: ":getPropFrom('sortByUpvotes')(id) == true",
      },
      {
        identifier: 'contributionToEdit',
        query: ": getVolatileProp($$templateParent, 'contributionToEdit', '')",
      },
      {
        identifier: 'toolsActiveFor',
        query: ": getVolatileProp($$templateParent, 'showTools', '')",
      },
      {
        identifier: 'isHost',
        query: ":hasRole($roles)('host')($me)",
      },
      {
        identifier: 'randomColors',
        query: ":getPropFrom('randomColors')(id)==true",
      },
      {
        identifier: 'grid',
        query: ":getPropFrom('grid')(id)==true",
      },
    ],
  },
  sheet: {
    orientTowardsCamera: false,
  },
};

const BrainstormingCollection: DataDocument = {
  id: 'BrainstormingCollection',
  info: {
    title: 'Brainstorming-Nachrichten',
  },
  tag: {
    tag: 'collection',
  },
  parentId: 'BrainstormingToolInstance',
  list: {
    items: [],
  },
};

export const PresetCollectionBrainstorming: PresetDefinition = {
  id: 'PresetCollectionBrainstorming',
  title: 'Brainstorming',
  icon: 'comments',
  group: 'tools',
  version: '0.1',
  documents: [BrainstormingToolInstance, BrainstormingCollection],
};
